
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getPlataform } from "@/util/get-plataform";

@Component({
  components: {}
})
export default class RightClickMenuItem extends Vue {
  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: "" })
  shortcut!: string;

  @Prop({ default: () => [] })
  subItems!: any[];

  get isMac() {
    const platform = getPlataform().toLowerCase();
    return /mac/.test(platform);
  }
}
